
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Familyresortneargadchiroli() {



  const cardData =
  {
    keyword: ' Family Resort Near Gadchiroli',
    heading:  'Woodland Escape: Family Resort Near Gadchiroli ',
    headingDescription: 'Woodland Escape Resort is the perfect family resort near Gadchiroli, offering a tranquil getaway where every member—from kids to grandparents—can relax, explore and enjoy together. Nestled amid verdant greenery, spacious lawns and peaceful forest-fringed surroundings, the resort invites families to bond over nature walks, outdoor games and picnic-style relaxation in the fresh air. Comfortable cottages, warm hospitality, and wholesome meals make the stay easy and stress-free, while shaded play areas and wide open spaces let children run free and adults unwind. With all-inclusive amenities and a safe, welcoming atmosphere, Woodland Escape Resort near Gadchiroli turns a family outing into a refreshing retreat filled with togetherness, nature and memorable moments.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Family Resort Near Gadchiroli",
      "description": "Discover the best family resorts near Gadchiroli offering comfortable accommodations, recreational facilities, and scenic surroundings perfect for a memorable family getaway."
    },
    {
      "name": "Gadchiroli Family Stay Resort",
      "description": "Enjoy a relaxing stay at Gadchiroli’s family-friendly resorts featuring cozy rooms, open spaces, and activities suitable for all age groups."
    },
    {
      "name": "Affordable Family Resort Gadchiroli",
      "description": "Experience budget-friendly family resorts in Gadchiroli that provide quality amenities, entertainment, and a peaceful environment without stretching your budget."
    },
    {
      "name": "Gadchiroli Weekend Family Resort",
      "description": "Plan a refreshing weekend getaway at Gadchiroli’s family resorts with fun activities, scenic surroundings, and comfortable stays for all family members."
    },
    {
      "name": "Gadchiroli Kids Friendly Resort",
      "description": "Take your children to Gadchiroli’s kid-friendly resorts with safe play areas, engaging activities, and green spaces for an enjoyable family experience."
    },
    {
      "name": "Gadchiroli Family Outing Resort",
      "description": "Plan a complete family outing at Gadchiroli resorts offering recreational activities, outdoor games, and ample space for relaxation and bonding."
    },
    {
      "name": "Gadchiroli Nature Resort for Families",
      "description": "Reconnect with nature at Gadchiroli’s nature resorts designed for families, surrounded by lush greenery, rivers, and hills for a peaceful retreat."
    },
    {
      "name": "Gadchiroli Riverside Family Resort",
      "description": "Enjoy a serene riverside stay at Gadchiroli’s family resorts offering picturesque water views, outdoor activities, and comfortable accommodations."
    },
    {
      "name": "Gadchiroli Hill Resort for Family",
      "description": "Escape to hilltop family resorts in Gadchiroli featuring panoramic views, fresh air, and opportunities for trekking, nature walks, and photography."
    },
    {
      "name": "Gadchiroli Family Picnic Resort",
      "description": "Plan a family picnic with an overnight stay at Gadchiroli resorts that provide open lawns, picnic facilities, and kid-friendly recreational activities."
    },
    {
      "name": "Gadchiroli Outdoor Family Resort",
      "description": "Experience outdoor recreation at Gadchiroli family resorts with spaces for games, barbecues, group activities, and nature exploration."
    },
    {
      "name": "Gadchiroli Group Family Resort",
      "description": "Perfect for group family trips, Gadchiroli resorts offer spacious accommodations, group activities, and fun-filled experiences for large families."
    },
    {
      "name": "Gadchiroli Family Resort Booking",
      "description": "Book your family resort in Gadchiroli in advance to ensure a comfortable stay with all amenities, recreational activities, and scenic surroundings."
    },
    {
      "name": "Gadchiroli One Day Family Resort",
      "description": "Enjoy a fun-filled one-day family outing at Gadchiroli resorts featuring games, relaxation spots, and scenic locations without the need for overnight stay."
    },
    {
      "name": "Gadchiroli Luxury Family Resort",
      "description": "Experience luxury family resorts in Gadchiroli with premium amenities, spacious rooms, fine dining, and recreational activities for an unforgettable stay."
    }
  ],
  "tableData": [
    ["- Family Resort Near Gadchiroli", "- Gadchiroli Family Stay Resort"],
    ["- Affordable Family Resort Gadchiroli", "- Gadchiroli Weekend Family Resort"],
    ["- Gadchiroli Kids Friendly Resort", "- Gadchiroli Family Outing Resort"],
    ["- Gadchiroli Nature Resort for Families", "- Gadchiroli Riverside Family Resort"],
    ["- Gadchiroli Hill Resort for Family", "- Gadchiroli Family Picnic Resort"],
    ["- Gadchiroli Outdoor Family Resort", "- Gadchiroli Group Family Resort"],
    ["- Gadchiroli Family Resort Booking", "- Gadchiroli One Day Family Resort"],
    ["- Gadchiroli Luxury Family Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Best Family Resort Near Gadchiroli",
    "WhyChoosedescription": "Woodland Escape Resort is an ideal family-friendly destination near Gadchiroli. Surrounded by lush greenery and serene landscapes, it offers a safe and enjoyable environment for families to relax and bond."
  },
  {
    "WhyChooseheading": "Peaceful and Natural Surroundings",
    "WhyChoosedescription": "Nestled amidst trees and open green spaces, the resort provides a calm and refreshing atmosphere. Families can spend quality time together while enjoying the beauty and tranquility of nature."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Accommodation",
    "WhyChoosedescription": "The resort features well-appointed rooms and cottages designed for families. With ample space and modern amenities, it ensures a comfortable and pleasant stay for guests of all ages."
  },
  {
    "WhyChooseheading": "Activities for Family Fun",
    "WhyChoosedescription": "Woodland Escape Resort offers a variety of family-friendly activities such as nature walks, cycling, outdoor games, and pond-side relaxation, making it enjoyable for both kids and adults."
  },
  {
    "WhyChooseheading": "Perfect for Weekend Getaways",
    "WhyChoosedescription": "Whether for a weekend escape or a day trip, the resort is ideal for families looking to unwind, have fun, and create lasting memories together."
  },
  {
    "WhyChooseheading": "Delicious Food Options",
    "WhyChoosedescription": "Families can enjoy freshly prepared local meals, snacks, and beverages. The resort ensures a delightful culinary experience alongside a relaxing stay."
  },
  {
    "WhyChooseheading": "Easily Accessible from Gadchiroli",
    "WhyChoosedescription": "Located just a short drive from Gadchiroli, Woodland Escape Resort is convenient for families seeking a quick, refreshing retreat close to the city."
  }
]





















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a family resort near Gadchiroli?",
    answer: "Woodland Escape Resort is an ideal family resort near Gadchiroli, offering a safe, green, and serene environment. Families can enjoy quality time together with outdoor activities, open lawns, and peaceful surroundings."
  },
  {
    question: "How far is Woodland Escape Resort from Gadchiroli city?",
    answer: "The resort is conveniently located within driving distance from Gadchiroli, making it perfect for a family day trip or a weekend stay. It’s easily accessible while still offering a tranquil escape from the city."
  },
  {
    question: "What facilities are available for families at Woodland Escape Resort?",
    answer: "The resort features spacious lawns, play areas for children, outdoor games, picnic spots, and comfortable accommodation. It’s designed to ensure fun and relaxation for every member of the family."
  },
  {
    question: "Is Woodland Escape Resort suitable for families with kids?",
    answer: "Absolutely! The resort is family-friendly with safe surroundings, kid-friendly zones, and plenty of activities to keep children engaged while adults relax and enjoy the scenic beauty."
  },
  {
    question: "Does the resort provide food and refreshments for families?",
    answer: "Yes, Woodland Escape Resort offers freshly prepared meals, snacks, and beverages. Family packages can include lunch and refreshments, making your visit hassle-free and enjoyable."
  },
  {
    question: "How can we book a stay or visit at Woodland Escape Resort near Gadchiroli?",
    answer: "Booking is simple — you can call or WhatsApp our reservations team, or visit the official website. Advance booking is recommended for weekends and holidays to secure your preferred dates."
  }
];

const testimonials = [
  {
    name: "Mr. Ramesh & Family, Gadchiroli",
    text: "Our family had an amazing stay at Woodland Escape Resort! The surroundings are peaceful, the kids enjoyed the play areas, and the food was excellent. Truly the best family resort near Gadchiroli."
  },
  {
    name: "Ms. Priya & Family, Gadchiroli",
    text: "Woodland Escape Resort is perfect for a family getaway. The green lawns, fun activities for kids, and relaxing environment made our weekend memorable. Highly recommended for families near Gadchiroli!"
  }
];























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Family Resort Near Gadchiroli",
  "image": "https://woodlandescape.com/assets/images/family-resort-gadchiroli.jpg",
  "description": "Enjoy a relaxing stay at Woodlandescape Resort, a family-friendly resort near Gadchiroli. Perfect for weekend getaways, kids-friendly activities, nature excursions, riverside and hill views, and group outings.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "95"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/family-resort-gadchiroli"
  }
};




  return (
    <div>
<Helmet>
  <title>Family Resort Near Gadchiroli | Weekend Getaways & Nature Stay | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Stay at Woodlandescape Resort, a family resort near Gadchiroli offering weekend getaways, kids-friendly activities, scenic hill and riverside views, and nature excursions for families." 
  />
  <meta 
    name="keywords" 
    content="Family Resort Near Gadchiroli, Gadchiroli Family Stay Resort, Affordable Family Resort Gadchiroli, Gadchiroli Weekend Family Resort, Gadchiroli Kids Friendly Resort, Gadchiroli Family Outing Resort, Gadchiroli Nature Resort for Families, Gadchiroli Riverside Family Resort, Gadchiroli Hill Resort for Family, Gadchiroli Family Picnic Resort, Gadchiroli Outdoor Family Resort, Gadchiroli Group Family Resort, Gadchiroli Family Resort Booking, Gadchiroli One Day Family Resort, Gadchiroli Luxury Family Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/30.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Familyresortneargadchiroli;